import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
import pakt21ApiUrl from '../../common/pakt21ApiUrl';

export default class ModerationDecisionModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);

    this.discussion = this.attrs.discussion;
    this.action = this.attrs.action;
    this.reason = Stream('');
  }

  className() {
    return 'Pakt21ModerationDecisionModal Modal--small';
  }

  title() {
    return app.translator.trans(
      `pakt21-beta.forum.moderation.${this.action}_title`
    );
  }

  content() {
    return (
      <div className="Modal-body">
        <div className="Form">
          <p className="helpText">
            {app.translator.trans(
              `pakt21-beta.forum.moderation.${this.action}_help`
            )}
          </p>
          <div className="Form-group">
            <label for="pakt21-moderation-reason">
              {app.translator.trans('pakt21-beta.forum.moderation.reason_label')}
            </label>
            <textarea
              id="pakt21-moderation-reason"
              name="reason"
              className="FormControl"
              rows="5"
              maxlength="500"
              required
              bidi={this.reason}
            />
            <p className="helpText">
              {app.translator.trans('pakt21-beta.forum.moderation.reason_help')}
            </p>
          </div>
          <div className="Form-group">
            <Button
              className="Button Button--primary Button--block"
              type="submit"
              loading={this.loading}
              disabled={!this.reason().trim()}
            >
              {app.translator.trans(
                `pakt21-beta.forum.moderation.${this.action}_submit`
              )}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  onsubmit(event) {
    event.preventDefault();

    const reason = this.reason().trim();

    if (!reason || this.loading) {
      return;
    }

    this.loading = true;

    return app
      .request({
        method: 'POST',
        url: pakt21ApiUrl(app.forum.attribute('apiUrl'), `/pakt21/moderation/discussions/${this.discussion.id()}/${this.action}`),
        body: {
          data: {
            type: 'pakt21-moderation-decisions',
            attributes: { reason },
          },
        },
      })
      .then(() => {
        const rejected = this.action === 'reject';

        this.discussion.pushData({
          attributes: {
            pakt21ModerationStatus: rejected ? 'rejected' : null,
            pakt21CanReject: !rejected,
            pakt21CanRestore: rejected && Boolean(app.session.user?.isAdmin()),
            isHidden: rejected,
            hiddenAt: rejected ? new Date().toISOString() : null,
          },
        });

        this.hide();
        m.redraw();
      })
      .catch((error) => {
        this.loading = false;
        this.onerror(error);
      });
  }
}
